import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3, Trophy, Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/stats/site`;
const JOURS = ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"];

/** Courbe de fréquentation des 7 derniers jours (Bastion). */
export const FrequentationChart = () => {
  const [serie, setSerie] = useState([]);
  const [courant, setCourant] = useState(null);
  const [pointe, setPointe] = useState(null);

  useEffect(() => {
    axios.get(`${API}/historique?jours=7`).then((r) => setSerie(r.data?.data || [])).catch(() => {});
    axios.get(`${API}/current`).then((r) => setCourant(r.data?.data)).catch(() => {});
    axios.get(`${API}/pointe`).then((r) => setPointe(r.data?.data)).catch(() => {});
  }, []);

  const max = Math.max(1, ...serie.map((j) => j.visiteurs_affiches || 0));
  const total = serie.reduce((s, j) => s + (j.visiteurs_affiches || 0), 0);

  return (
    <div
      className="bg-white border border-[#E5DFD5] rounded-2xl p-5"
      data-testid="bastion-frequentation"
    >
      <h3 className="font-semibold text-stone-900 flex items-center gap-2">
        <BarChart3 size={18} className="text-[#E05638]" /> Fréquentation — 7 derniers jours
      </h3>

      <div className="mt-5 flex items-stretch justify-between gap-2 h-36" data-testid="bastion-frequentation-barres">
        {serie.map((jour) => {
          const hauteur = Math.max(6, Math.round(((jour.visiteurs_affiches || 0) / max) * 100));
          const date = new Date(`${jour.date}T12:00:00Z`);
          return (
            <div key={jour.date} className="flex-1 flex flex-col items-center gap-1.5 group">
              <span className="text-[10px] font-bold text-stone-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                {jour.visiteurs_affiches}
              </span>
              <div className="relative flex-1 w-full">
                <div
                  data-testid={`bastion-barre-${jour.date}`}
                  title={`${jour.visiteurs_affiches} visiteurs (${jour.visiteurs_uniques} réels)`}
                  style={{ height: `${hauteur}%` }}
                  className="absolute bottom-0 left-0 w-full rounded-t-lg bg-gradient-to-t from-[#E05638] to-[#D4AF37] hover:opacity-80 transition-opacity duration-200"
                />
              </div>
              <span className="text-[10px] font-medium text-stone-500">
                {JOURS[date.getUTCDay()]} {date.getUTCDate()}
              </span>
            </div>
          );
        })}
      </div>

      <div className="mt-5 grid grid-cols-3 gap-3 text-center">
        <div>
          <div className="font-heading text-xl font-extrabold text-stone-900" data-testid="bastion-freq-total">
            {total.toLocaleString("fr-FR")}
          </div>
          <div className="text-[11px] text-stone-500">Visiteurs sur 7 jours</div>
        </div>
        <div>
          <div className="font-heading text-xl font-extrabold text-[#0A5C36] flex items-center justify-center gap-1">
            <Trophy size={15} />
            <span data-testid="bastion-freq-record">
              {(courant?.global?.record_visiteurs || 0).toLocaleString("fr-FR")}
            </span>
          </div>
          <div className="text-[11px] text-stone-500">
            Record {courant?.global?.record_jour ? `(${courant.global.record_jour})` : "à battre"}
          </div>
        </div>
        <div>
          <div className="font-heading text-xl font-extrabold text-[#E05638] flex items-center justify-center gap-1">
            <Flame size={15} />
            <span data-testid="bastion-freq-pointe">{pointe?.libelle || "—"}</span>
          </div>
          <div className="text-[11px] text-stone-500">Heure de pointe du jour</div>
        </div>
      </div>
    </div>
  );
};

export default FrequentationChart;
